import React, { useEffect, useState } from "react";
import CardsGrid from "../../Components/CardsGrid";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Header";
import PortfolioCard from "../../Components/PortfolioCard";
import Pricing from "../../Components/PricingTable";
import socialMediaAnimatedPost from "../../Images/Branding Icons/Animated Post.png";
import banner from "../../Images/Branding Icons/Banner.png";
import Booklets from "../../Images/Branding Icons/Booklet.png";
import BusinessCard from "../../Images/Branding Icons/Bussiness Card.png";
import certificates from "../../Images/Branding Icons/Certificate.png";
import creativeads from "../../Images/Branding Icons/creative ads.png";
import email from "../../Images/Branding Icons/Email Templet.png";
import info from "../../Images/Branding Icons/info graphics.png";
import LogoDesign from "../../Images/Branding Icons/Logo Design.png";
import motion from "../../Images/Branding Icons/motion graphics.png";
import packaging from "../../Images/Branding Icons/packging.png";
import socialMediaPost from "../../Images/Branding Icons/socialmediapost.png";
import thumbnail from "../../Images/Branding Icons/thumbnail.png";
import appinterface from "../../Images/Branding Icons/UX.png";
import bgplans from "../../Images/Frame.png";
import bghero from "../../Images/Framemission.png";
import img5 from "../../Images/graphicPortfolio/ads.jpeg";
import img4 from "../../Images/graphicPortfolio/flyers.jpeg";
import img1 from "../../Images/graphicPortfolio/logos.jpeg";
import img6 from "../../Images/graphicPortfolio/posts.jpeg";
import img2 from "../../Images/graphicPortfolio/socialcamp.jpeg";
import img3 from "../../Images/graphicPortfolio/websites.jpeg";
import graphicservice from "../../Images/Graphics PNG/Branding.png";
import bgteal from "../../Images/tealback.png";
const words = ["Unique", "High-Quality", "Specialized", "Exclusive"];

const GraphicDesignService = () => {
  const [currentWord, setCurrentWord] = useState(0); // Start with the first word
  const [animate, setAnimate] = useState(false); // For triggering animation
  const words = ["Unique", "High-Quality", "Specialized", "Exclusive"];

  const cardsData = [
    {
      title: "Social Media Posts",
      description: "Create engaging posts tailored for social media platforms.",
      Icon: socialMediaPost,
    },
    {
      title: "Social Media Animated Posts",
      description: "Boost engagement with animated posts for social media.",
      Icon: socialMediaAnimatedPost,
    },
    {
      title: "Logo Design",
      description: "Create unique logos that represent your brand.",
      Icon: LogoDesign,
    },
    {
      title: "Business Cards",
      description:
        "Design professional business cards to leave a lasting impression.",
      Icon: BusinessCard,
    },
    {
      title: "Booklets",
      description:
        "Create informative booklets for events, businesses, or products.",
      Icon: Booklets,
    },
    {
      title: "Certificates",
      description: "Design certificates for recognition or achievements.",
      Icon: certificates,
    },
    {
      title: "Website Banners",
      description: "Create visually appealing banners for your website.",
      Icon: banner,
    },
    {
      title: "App Interface Design (UI/UX)",
      description: "Design intuitive and attractive user interfaces for apps.",
      Icon: appinterface,
    },
    {
      title: "Email Templates",
      description:
        "Create engaging and responsive email templates for campaigns.",
      Icon: email,
    },
    {
      title: "Infographics",
      description:
        "Design infographics that make complex data visually engaging.",
      Icon: info,
    },
    {
      title: "Packaging Design",
      description:
        "Design product packaging that stands out and attracts customers.",
      Icon: packaging,
    },
    {
      title: "Creative Ads for Google Campaigns",
      description:
        "Design compelling ads that drive conversions for Google campaigns.",
      Icon: creativeads,
    },
    {
      title: "Motion Graphics (Intro/Outro)",
      description:
        "Create professional motion graphics for videos and presentations.",
      Icon: motion,
    },
    {
      title: "Thumbnails",
      description:
        "Design engaging video thumbnails for YouTube or other platforms.",
      Icon: thumbnail,
    },
  ];

  const projects = [
    {
      name: "Creative Logo Design",
      tags: ["Logo", "Business Cards", "Brand Style Guides"],
      img: img1,
    },
    {
      name: "Social Media Campaign",
      tags: ["Social Media Posts", "Animated Posts", "Banners"],
      img: img2,
    },
    {
      name: "Website Mockups",
      tags: ["Website Layouts/Mockups", "Website Banners"],
      img: img3,
    },
    {
      name: "Corporate Flyers",
      tags: ["Flyers", "Business Cards", "Infographics"],
      img: img4,
    },
    {
      name: "Google Ads Creative",
      tags: ["Creative Ads for Google Campaigns", "Thumbnails"],
      img: img5,
    },
    {
      name: "Social Media Posts",
      tags: ["Instagram", "Facebook", "Twitter"],
      img: img6,
    },
  ];

  const plans = [
    {
      name: "Basic",
      description:
        "A perfect starter package to establish your brand identity with essential elements.",
      features: [
        "Custom logo with 3 concepts and 2 revisions",
        "Primary and secondary brand colors",
        "Font selection and usage guidelines",
        "Basic brand guidelines for logo, colors, and typography",
      ],
    },

    {
      name: "Standard",
      description:
        "Enhance your brand with comprehensive design assets and detailed guidelines.",
      features: [
        "5 logo concepts with unlimited revisions",
        "Custom color palette with usage guidelines",
        "Comprehensive font selection and usage",
        "Detailed brand guidelines document",
        "Custom-designed business cards",
        "Branded social media templates",
      ],
      popular: true,
    },
    {
      name: "Premium",
      description:
        "Complete brand solutions with extensive design elements and strategic branding services.",
      features: [
        "Unlimited logo concepts and revisions",
        "Extensive color palette with detailed guidelines",
        "Complete typography system for brand communication",
        "Full brand book covering all identity aspects",
        "Custom designs for business cards and stationery",
        "Branded social media profiles and post templates",
        "Brand story development reflecting mission and values",
        "Custom packaging design aligned with brand identity",
      ],
    },
  ];

  useEffect(() => {
    // Change word every second
    const interval = setInterval(() => {
      setAnimate(true); // Trigger the animation

      setTimeout(() => {
        setCurrentWord((prevWord) => (prevWord + 1) % words.length); // Change the word
        setAnimate(false); // Reset the animation
      }, 500); // Duration of the animation (0.5s)
    }, 1000); // Change word every second

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, []);

  return (
    <div className="mb-4">
      <div
        className="min-h-screen -z-0"
        style={{
          backgroundImage: `url(${bghero})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed", // Fix background movement
        }}
      >
        <div className="">
          <Navbar color={"bg-teal-950 text-white"} />
        </div>

        <div className="z-10 lg:h-screen  max-w-7xl mx-auto px-8  lg:px-8 flex flex-col md:flex-row lg:flex-row gap-8 md:gap-0 lg:gap-4 pb-20 lg:pt-12  ">
          {/* Left Side: Text Section */}
          <div className="flex flex-col justify-center w-full lg:w-1/2 md:w-1/2 mt-6 md:mt-6 lg:mt-10">
            <h1 className="relative h-12 mb-2 md:mb-4 lg:mb-4">
              {/* Animated word */}
              <span
                className={`absolute transition-transform duration-500 ease-in-out  text-2xl md:text-3xl lg:text-4xl font-bold text-teal-500`}
              >
                {words[currentWord]}
              </span>
            </h1>

            <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold mb-6 text-teal-800">
              Graphic Design Services
            </h2>
            <p className="text-gray-600 mb-8 text-md md:text-base lg:text-lg">
              Ignite the force of visual storytelling, from bespoke
              illustrations to captivating infographics, our talented artists
              sculpt mesmerizing designs that deeply connect with your audience
              and amplify your brand's message.
            </p>
           
          </div>

          {/* Right Side: Image Section */}
          <div className=" flex-col lg:flex-row md:flex-row justify-center items-center lg:justify-end w-full lg:w-1/2 md:w-1/2 hidden  md:block lg:block">
            <img
              src={graphicservice}
              alt="Illustration Design"
              className="w-[300px] h-[200px] md:w-[500px] md:h-[400px] lg:w-[600px] lg:h-[500px]"
            />
          </div>
        </div>

        {/* Services Section */}
        <CardsGrid
          cardsData={cardsData}
          heading={"Creative Graphic Design Solutions"}
        />

        {/* Portfolio Section */}
        <div
          className=" mx-auto  px-1 md:px-4 lg:px-8 flex flex-col gap-8 text-white py-16"
          style={{
            backgroundImage: `url(${bgteal})`,
            backgroundSize: "cover",
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed", // Fix background movement
          }}
        >
          <div className="overflow-hidden">
            <div className="mt-12 max-w-7xl mx-auto px-8 bg-transparent">
              <h2 className="text-center text-4xl font-bold mb-10 text-white">
                Our Work Portfolio
              </h2>
              <p className="text-center text-normal font-md mb-12 text-white">
                Explore our diverse portfolio showcasing creative and innovative
                graphic design solutions tailored to bring your vision to life.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {projects.map((project, index) => (
                  <PortfolioCard
                    key={index}
                    projectName={project.name}
                    tags={project.tags}
                    img={project.img}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Section */}

        <div
          className="w-full  mx-auto  "
          style={{
            backgroundImage: `url(${bgplans})`,
            backgroundSize: "cover",
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed", // Fix background movement
          }}
        >
          <Pricing plans={plans} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GraphicDesignService;
